import { GridInput } from '../grid';
import { ReceivedFileInterface as File } from '../../types/FileInterface';

export interface Return {
    id?: number;
    eshopReturnId: string;
    eshopOrderId?: string | null;
    trackingNumber?: string | null;
    description?: string | null;
    shipperServiceCode: string | null;
    orderType?: string;
    shipper?: string | null;
    status?: string | null;
    returnedOrderProducts?: ReturnProduct[];
    note?: string | null;
    files?: File[];
    rma: string;
    createdAt: string;
    eshopNote?: string | null;
    canceledAt?: string | null;
    confirmedAt?: string | null;
    receivedAt?: string | null;
    sourceSys?: string | null;
    transportPaidBy?: string | null;
    orderId?: number | null;
    partnerOrderId?: string | null;
    senderStreet?: string | null;
    senderCity?: string | null;
    senderState?: string | null;
    senderPostcode?: string | null;
    senderPhone?: string | null;
    /** Only returned by the grid endpoint — comes from the linked order, not from the return itself. */
    recipientName?: string | null;
    /** Only returned by the grid endpoint — the shipper of the linked outbound order. */
    orderShipper?: string | null;
    /** Only returned by the grid endpoint — the shipper service code of the linked outbound order. */
    orderShipperServiceCode?: string | null;
    /** Only returned by the grid endpoint — the tracking number of the linked outbound order. */
    orderTrackingNumber?: string | null;
}

export interface ReturnProduct {
    quantity: number;
    returnReason?: string;
    resolution?: string | null;
    serialNumber: string | null;
    sku: string;
    lineState: string;
    received?: number;
}

export interface ReturnsGridOutput {
    data: Return[];
    request: GridInput;
    totalCount: number;
}

export const toCoreReturnNames = {
    id: 'ID',
    description: 'DESCRIPTION',
    eshopReturnId: 'ESHOP_RETURN_ID',
    eshopOrderId: 'ESHOP_ORDER_ID',
    note: 'NOTE',
    orderType: 'ORDER_TYPE',
    shipper: 'SHIPPER',
    shipperServiceCode: 'SHIPPER_SERVICE_CODE',
    status: 'STATUS',
    trackingNumber: 'TRACKING_NUMBER',
    rma: 'RMA',
    createdAt: 'CREATED_AT',
    eshopNote: 'ESHOP_NOTE',
    canceledAt: 'CANCELED_AT',
    confirmedAt: 'CONFIRMED_AT',
    receivedAt: 'RECEIVED_AT',
    sourceSys: 'SOURCE_SYS',
    transportPaidBy: 'TRANSPORT_PAID_BY',
    orderId: 'ORDER_ID',
    partnerOrderId: 'PARTNER_ORDER_ID',
    recipientName: 'RECIPIENT_NAME',
    orderShipper: 'ORDER_SHIPPER',
    orderShipperServiceCode: 'ORDER_SHIPPER_SERVICE_CODE',
    orderTrackingNumber: 'ORDER_TRACKING_NUMBER',
    senderStreet: 'SENDER_STREET',
    senderCity: 'SENDER_CITY',
    senderState: 'SENDER_STATE',
    senderPostcode: 'SENDER_POSTCODE',
    senderPhone: 'SENDER_PHONE',
};

export const fromCoreReturnNames = {
    ID: 'id',
    DESCRIPTION: 'description',
    ESHOP_RETURN_ID: 'eshopReturnId',
    ESHOP_ORDER_ID: 'eshopOrderId',
    NOTE: 'note',
    ORDER_TYPE: 'orderType',
    SHIPPER: 'shipper',
    SHIPPER_SERVICE_CODE: 'shipperServiceCode',
    STATUS: 'status',
    TRACKING_NUMBER: 'trackingNumber',
    CANCELED_AT: 'canceledAt',
    CONFIRMED_AT: 'confirmedAt',
    RECEIVED_AT: 'receivedAt',
    RMA: 'rma',
    CREATED_AT: 'createdAt',
    ESHOP_NOTE: 'eshopNote',
    SOURCE_SYS: 'sourceSys',
    TRANSPORT_PAID_BY: 'transportPaidBy',
    ORDER_ID: 'orderId',
    PARTNER_ORDER_ID: 'partnerOrderId',
    SENDER_STREET: 'senderStreet',
    SENDER_CITY: 'senderCity',
    SENDER_STATE: 'senderState',
    SENDER_POSTCODE: 'senderPostcode',
    SENDER_PHONE: 'senderPhone',
    RECIPIENT_NAME: 'recipientName',
    ORDER_SHIPPER: 'orderShipper',
    ORDER_SHIPPER_SERVICE_CODE: 'orderShipperServiceCode',
    ORDER_TRACKING_NUMBER: 'orderTrackingNumber',
};
